import {
   AfterContentChecked,
   Component,
   computed,
   inject,
   Input,
   OnChanges,
   SimpleChanges
} from '@angular/core'
import { RouterLink } from '@angular/router'
import { Observable, tap } from 'rxjs'
import { AppSignals, AuthService, CommonService } from '@appShared/services'
import { UrlService } from '@appShared/services/url.service'
//import { HybridWebviewInteropService } from '@appShared/services/hybrid-webview-interop.service'
import { ContentRegistrationProgressesService } from '@appShared/services/content-registration-progresses.service'
import {
   LeadSection,
   LeadSections,
   LeadSection_
} from '@appShared/services/lookup/lead-section'
import { IContactPartitionProgress } from '@appShared/interfaces/[Model-based]/contact-partition-progress.interface'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
    selector: 'app-internal-header',
    templateUrl: './internal-header.component.html',
    styleUrls: ['./internal-header.component.less'],
    imports: [RouterLink]
})
export class InternalHeaderComponent implements OnChanges, AfterContentChecked {
   @Input() leadSection: LeadSection

   private _commonService = inject(CommonService)
   private _urlService = inject(UrlService)
   private _authService = inject(AuthService)
   private _contentRegistrationProgressesService = inject(ContentRegistrationProgressesService)

   contactPartitionProgress$: Observable<IContactPartitionProgress>
   headerTitle$: Observable<string>
   user = inject(AppSignals).currentUser
   displayName = computed(() => this.user().profile?.contact?.firstName || this.user().displayName)
   //isDotNetInteroperable = toSignal(inject(HybridWebviewInteropService).isDotNetInteroperable$)
   routes = SITE_DIRECTORY_ROUTES

   private _initialLeadSection = LeadSections.find(
      section => section.code === LeadSection_.Home
   );

   constructor(
   ) {
      this.contactPartitionProgress$ = this._contentRegistrationProgressesService.contactPartitionProgress$
         .pipe(
            tap(contactPartitionProgress => {
               console.log(`contactPartitionProgress$:`, contactPartitionProgress)
            })
         )
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes && !changes['leadSection']) {
         this.leadSection == this._initialLeadSection
      }
   }

   ngAfterContentChecked(): void {
      setTimeout(() => { this.headerTitle$ = this._urlService.headerTitle$ })
   }

   /*
   * public methods
   * */

   comingSoon(areaName?: string) {
      const message = areaName ? `"${areaName}" feature is coming soon.` : ''
      this._commonService.comingSoon(message)
   }

   logout() {
      this._authService.logout()
   }
}
